// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { dangerColor, primaryFocusColor, profileHrColor, reset } from "../../utils/commonJssConstants";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const tabLabelColor = "#333333";

export const UGContentCreatePageStyles = (config: DesignSystem) => ({
    ugContentCreatePageContainer: {
        ...reset,
        display: "flex",
        "flex-direction": "column",
        "background-color": "#FFFFFF",

        "& .cwt-ugc-create-header": {
            display: "flex",
            "align-items": "center",
            "justify-content": "space-between",
            "border-bottom": "1px solid ",
            "border-color": profileHrColor,

            "& .cwt-nav-buttons": {
                display: "flex",
                padding: "7px 0",
                "flex-wrap": "wrap",
                "align-items": "center",

                "& .cwt-fast-button": {
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "9px"
                }
            },

            "& .cwt-profile-tabs": {
                position: "sticky",
                top: "0",
                "z-index": "1",
                margin: "0",
                padding: "0 18px",
                background: neutralLayerCard,
                "overflow-x": "scroll",
                "list-style": "none",

                // 'Hide scrollbar'
                "-ms-overflow-style": "none",

                "&::-webkit-scrollbar": {
                    display: "none"
                },

                "& .cwt-tab-item": {
                    cursor: "pointer",
                    position: "relative",
                    padding: "15px 0",
                    "font-size": "13px",
                    color: tabLabelColor,
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "24px",
                    background: "none",

                    "&:first-child": {
                        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
                    },

                    "&:hover": {
                        color: accentFillRest,
                        "font-weight": "600",

                        "&:after": {
                            position: "absolute",
                            "z-index": "10",
                            content: "' '",
                            height: "3px",
                            width: "100%",
                            "margin-top": "calc(15px - 3px)",
                            [applyLocalizedProperty("left", "right", config.direction)]: "0",
                            background: accentFillRest
                        },

                        "& .cwt-icon-label": {
                            color: accentFillRest
                        }
                    },

                    "& .cwt-icon": {
                        color: "inherit",
                        "white-space": "nowrap",
                        height: "18px"
                    },

                    "& .cwt-icon-label": {
                        color: tabLabelColor,
                        "font-size": "13px"
                    }
                }
            }
        },
        "& .cwt-status-text": {
            padding: "0px 10px",
            "line-height": "35px",

            "&.success": {
                color: primaryFocusColor
            },

            "&.pending": {
                color: dangerColor
            }
        }
    }
});